import { RouteType } from "types/RouteType";
import RoutingIssuesStore from "./RoutingIssuesStore";

/**
 * Meeting Intelligence → **Routing Issues** — the safeguard that replaced the
 * approval queue (plan/2026-09-18_suggestions-and-ado-as-a-ticket-database.md).
 *
 * `requiresPermission: false` and no tier gate here, for the same reason
 * `analysisQueue.Route` gives: THE SERVICE GATES ITSELF. `action-routing-issues`
 * is staff-only and refuses API keys outright, so a viewer who reaches this
 * route gets an error rather than data. A second gate in the route could only
 * drift from the real one — and the real one is the server's.
 */
const routingIssuesRoute: RouteType[] = [
  {
    name: "RoutingIssues",
    path: "/action-routing-issues",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Routing Issues",
        enableRefreshButton: true,
        component: () => import("./RoutingIssues.Header"),
      },
      body: {
        component: () => import("./RoutingIssues.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    searchAliases: [
      "unassigned work",
      "unroutable",
      "no work item",
      "azure devops project",
      "stuck action items",
      "who owns this",
    ],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.routingIssuesStore as RoutingIssuesStore;
      void store?.load();
      void store?.loadClients();
    },
  },
];

export default routingIssuesRoute;
